import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=9a55feae&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a55feae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a55feae')) {
      api.createRecord('9a55feae', component.options)
    } else {
      api.reload('9a55feae', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=9a55feae&scoped=true&", function () {
      api.rerender('9a55feae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25NPdww4xu75f/JS/comp/Accordion.vue"
export default component.exports